import { Badge } from "@devhop/ui";
import {
  formatPriorityOrderLabel,
  getPriorityOrderBadgeClass,
} from "../lib/priority-order";

type PriorityOrderBadgeProps = {
  priorityOrder: number | null | undefined;
  /** ใส่ prefix เช่น "ຄວາມສຳຄັນ: " */
  prefix?: string;
  className?: string;
  title?: string;
};

export function PriorityOrderBadge({
  priorityOrder,
  prefix,
  className,
  title,
}: PriorityOrderBadgeProps) {
  const label = formatPriorityOrderLabel(priorityOrder);
  const colorClass = getPriorityOrderBadgeClass(priorityOrder);

  return (
    <Badge
      variant="outline"
      className={[colorClass, className].filter(Boolean).join(" ")}
      title={
        title ??
        (priorityOrder != null
          ? `ລຳດັບ ${priorityOrder} — ເລກນ້ອຍສຳຄັນກວ່າ`
          : undefined)
      }
    >
      {prefix ? `${prefix}${label}` : label}
    </Badge>
  );
}
